/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum AvanakCampaignNumberStatus {
  Sent = 1,
  Wait = 2,
  Answered = 3,
  Congestion = 4,
  NoAnswer = 5,
  Busy = 7
}
